<template>
  <div class="component">
    <div class="content">
      <h1 class="clearfix">
        <i class="el-icon-warning"></i>
        <span>{{ fixTable.name }}: {{ $t('477') }}</span>
      </h1>
      <!-- 固定薪资 -->
      <el-collapse v-model="activeNames1">
        <el-collapse-item v-for="(item, index) in fixTable.list" :key="index" :name="index">
          <template slot="title">
            <div>
              <span>{{ item.name }}</span>
              <span class="tip">{{
                activeNames1.includes(index) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <el-table
            :data="item.list"
            :ref="'fixTable' + index"
            @selection-change="notFixTableSelectHandle($event, index, 'fixTable')"
          >
            <el-table-column type="selection" width="65" :selectable="selectable"></el-table-column>
            <el-table-column
              v-for="clo in fixClo[index]"
              :key="clo.name"
              :label="$t(clo.label)"
              :prop="clo.prop"
              :min-width="clo.width"
              :fixed="clo.fixed"
            >
              <template slot-scope="scope">
                <!-- 计薪天数（天） -->
                <template v-if="clo.type === 'number'">
                  <template v-if="scope.row.is_input === '1'">
                    <el-input-number
                      class="input-number"
                      size="small"
                      v-model="scope.row.val"
                      controls-position="right"
                      @blur="check(scope.row, 31)"
                      :min="1"
                      :max="31"
                    />
                  </template>
                </template>
                <!-- 不计算天数规则 -->
                <template v-else-if="clo.type === 'select'">
                  <template v-if="scope.row.days_type === '0'"></template>
                  <template v-if="scope.row.days_type === '1'">
                    <el-select
                      v-model="scope.row.days"
                      multiple
                      collapse-tags
                      style="width: 100%"
                      :placeholder="$t('221')"
                      size="small"
                    >
                      <el-option v-for="(item, index) in days" :key="index" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="scope.row.days_type === '2'">
                    <el-select
                      v-model="scope.row.not_days"
                      multiple
                      collapse-tags
                      style="width: 100%"
                      :placeholder="$t('221')"
                      size="small"
                    >
                      <el-option v-for="(item, index) in not_days" :key="index" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </template>
                <template v-else>{{ scope.row[clo.prop] }}</template>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="content">
      <h1 class="clearfix">
        <i class="el-icon-warning"></i>
        <span>{{ notFixTable.name }}: {{ $t('479') }}</span>
      </h1>
      <!-- 不固定薪资 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(table, tableIndex) in notFixTable.list"
          :key="tableIndex"
          :title="table.name"
          :name="tableIndex"
        >
          <template slot="title">
            <div>
              <span>{{ table.name }}</span>
              <span class="tip">{{
                activeNames.includes(tableIndex) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <!-- ot_days -->
          <div v-if="table.id === '7'" class="ot">
            {{ $t('491') }}
            <el-tooltip class="item" effect="dark" :content="$t('ot_text')" placement="top-start">
              <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
            </el-tooltip>
            <el-input-number
              class="input-number"
              size="small"
              v-model="table.ot_days.val"
              controls-position="right"
              @change="handleOtDays(table.ot_days)"
              :min="1"
            />
          </div>
          <el-table
            :data="table.list"
            @selection-change="notFixTableSelectHandle($event, tableIndex, 'notFixTable')"
            :ref="'notFixTable' + tableIndex"
            v-if="table.list.length"
          >
            <el-table-column type="selection" width="65" :selectable="selectable"></el-table-column>
            <el-table-column
              v-for="clo in notFixClo[tableIndex]"
              :fixed="clo.fixed"
              :key="clo.label"
              :label="$t(clo.label)"
              :prop="clo.prop"
              :min-width="clo.width"
            >
              <template slot-scope="scope">
                <!-- 计算天数规则 table.id不为8展示-->
                <template v-if="clo.type === 'select'">
                  <!-- 下拉框 -->
                  <template v-if="table.id !== '8'">
                    <template v-if="scope.row.days_type === '0'"></template>
                    <template v-if="scope.row.days_type === '1'">
                      <el-select
                        v-model="scope.row.days"
                        multiple
                        collapse-tags
                        style="width: 100%"
                        :placeholder="$t('221')"
                        size="small"
                      >
                        <el-option v-for="(item, index) in days" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                    <template v-if="scope.row.days_type === '2'">
                      <span>{{ scope.row[clo.prop] }}</span>
                      <el-select
                        v-model="scope.row.not_days"
                        multiple
                        collapse-tags
                        style="width: 100%"
                        :placeholder="$t('221')"
                        size="small"
                      >
                        <el-option
                          v-for="(item, index) in not_days"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </template>
                </template>
                <!-- 是否计算税 是否计算社保 -->
                <template v-else-if="clo.type === 'switch'">
                  {{ scope.row[clo.prop] }}
                  <el-switch v-model="scope.row[clo.value]"></el-switch>
                </template>
                <!-- 展示无type字段的内容 -->
                <template v-else>
                  {{ scope.row[clo.prop] }}
                </template>
              </template>
            </el-table-column>
          </el-table>
          <p v-if="!table.list.length && table.id" style="line-height: 40px; text-align: center">
            {{ $t('no_data') }}
          </p>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="content" v-if="$route.query.type === '1'">
      <h1 class="clearfix">
        <i class="el-icon-warning"></i>
        <span>{{ $t('i18n.69cc6dda91014b768da55656dfcfdb92') }}: {{ $t('479') }}</span>
      </h1>
      <el-collapse v-model="activeNames2">
        <!-- 调薪前后天数定义 -->
        <el-collapse-item :title="$t('i18n.447417ca7ba14106acd2124a12d0049c')" :name="0">
          <template slot="title">
            <div>
              <span>{{ $t('i18n.447417ca7ba14106acd2124a12d0049c') }}</span>
              <span class="tip">{{
                activeNames2.includes(0) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <el-button type="text" @click="checkExample('3')">{{
              $t('i18n.d7f42cdf6b274ccb8001286ce2ca250c')
            }}</el-button>
            <p class="salary-tip">
              {{ $t('i18n.ac29ddb3879c4f2ca984cac11424a739') }}
            </p>
            <el-radio-group
              v-model="extend.update_salary_day_last_later.type"
              @change="handleGroup('update_salary_day_last_later')"
              class="extend salary-con"
            >
              <el-radio :label="1">{{ $t('i18n.66257972feb64fc1b4923b6dc200ad93') }}</el-radio>
              <el-radio :label="2">{{ $t('i18n.7c3e88ab4c8d4941aa37e1a75af3ed6b') }}</el-radio>
              <el-radio :label="3">{{ $t('pay_slip_46') }}</el-radio>
              <div class="salary-con-sub">
                <p>
                  {{ $t('i18n.594dc41cfac14cbbb838557509660cc2') }}
                  <el-select
                    :disabled="extend.update_salary_day_last_later.type !== 3"
                    v-model="extend.update_salary_day_last_later.before"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.e49097738c4e4355bf708bd9ae09e557')" :value="1" />
                    <el-option :label="$t('i18n.7c3e88ab4c8d4941aa37e1a75af3ed6b')" :value="2" />
                  </el-select>
                </p>
                <p>
                  {{ $t('i18n.a5ffb4e6911b471186c25e03f95d22f7') }}
                  <el-select
                    :disabled="extend.update_salary_day_last_later.type !== 3"
                    v-model="extend.update_salary_day_last_later.after"
                    :placeholder="$t('221')"
                    size="small"
                  >
                    <el-option :label="$t('i18n.e49097738c4e4355bf708bd9ae09e557')" :value="1" />
                    <el-option :label="$t('i18n.7c3e88ab4c8d4941aa37e1a75af3ed6b')" :value="2" />
                  </el-select>
                </p>
              </div>
            </el-radio-group>
          </div>
        </el-collapse-item>
        <!-- 考勤归属 -->
        <el-collapse-item :title="$t('i18n.50879ac886644e56a3546cc0b66c65e5')" :name="1">
          <template slot="title">
            <div>
              <span>{{ $t('i18n.50879ac886644e56a3546cc0b66c65e5') }}</span>
              <span class="tip">{{
                activeNames2.includes(1) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <el-button type="text" @click="checkExample('4')">{{
              $t('i18n.d7f42cdf6b274ccb8001286ce2ca250c')
            }}</el-button>
            <p class="salary-tip">
              {{ $t('i18n.1eff3be2b58f45fe96f7d2a2ada90b1b') }}
            </p>
            <el-radio-group
              v-model="extend.attendance_belong_to.type"
              @change="handleGroup('attendance_belong_to')"
              class="extend salary-con"
            >
              <el-radio :label="1">{{ $t('i18n.68ec1cb8a54c4f74beb1d31502640b8f') }}</el-radio>
              <el-radio :label="2">{{ $t('i18n.129a912fddf546e99ac0116658e97e1f') }}</el-radio>
              <el-radio :label="3">{{ $t('i18n.4de9cd599c664be1ace17d94b175c4de') }}</el-radio>
            </el-radio-group>
          </div>
        </el-collapse-item>
        <!-- 加班计算设置 -->
        <el-collapse-item :title="$t('i18n.ebbd17a22ede44cfbdc4a7bfb995d166')" :name="2">
          <template slot="title">
            <div>
              <span>{{ $t('i18n.ebbd17a22ede44cfbdc4a7bfb995d166') }}</span>
              <span class="tip">{{
                activeNames2.includes(1) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <el-button type="text" @click="checkExample('5')">{{
              $t('i18n.d7f42cdf6b274ccb8001286ce2ca250c')
            }}</el-button>
            <p class="salary-tip">
              {{ $t('i18n.1021718e96ee47d182a8524c60630741') }}
            </p>
            <p class="salary-tip">
              {{ $t('i18n.48cd38a85e4c437a8ad15071aac426ee') }}
            </p>
            <el-radio-group
              v-model="extend.overtime_belong_to.type"
              @change="handleGroup('overtime_belong_to')"
              class="extend salary-con"
            >
              <el-radio :label="1">{{ $t('i18n.f71fcf1fac794b678b8f7f10c0d8b253') }}</el-radio>
              <el-radio :label="2">{{ $t('i18n.3fab5ae80e574b54822eb0f6e9132d69') }}</el-radio>
              <el-radio :label="3">{{ $t('i18n.0ea639e06c4d4e099adeacc1aa803832') }}</el-radio>
            </el-radio-group>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="content" v-if="is_show">
      <el-collapse v-model="activeNames3">
        <el-collapse-item :title="$t('payroll_management_20')" :name="1">
          <template slot="title">
            <div>
              <span>{{ $t('payroll_management_20') }}</span>
              <span class="tip">{{
                activeNames3.includes(1) ? $t('payroll_salary_13') : $t('payroll_salary_12')
              }}</span>
            </div>
          </template>
          <div class="salary-box">
            <Management :attendanceData="attendanceData" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <example ref="example" />
  </div>
</template>

<script>
import './directive'
import { get_salary, save_salary } from 'api/payroll/salary-scheme/detail'
import { isDeleteToast, deleteItemImport } from 'api/payroll/wage/step2'
import Management from '../../compontents/management.vue'
import example from '../components/example'
import { fullAttendanceBonusList } from '@/api/payroll/management'
export default {
  props: {
    activeObj: {
      type: Object
    }
  },
  components: {
    Management,
    example
  },
  data() {
    return {
      fixTable: {
        id: '',
        name: '',
        list: []
      }, // 上边的表格
      days: [], // 下拉框
      not_days: [], // 下拉框
      fixTableSelectArr: [], // 上面表格选中的
      activeNames: [0],
      activeNames1: [0],
      activeNames2: [0, 1, 2],
      activeNames3: [],
      notFixTable: {
        id: '',
        name: '',
        list: []
      }, // 下面的表格
      notFixTableSelectArr: [],
      activeData: this.activeObj.data,
      activeInfo: this.activeObj.data.info,
      cActiveInfo: this.activeObj.data.cInfo, // 拷贝数据，判断是否修改
      is_show: false, // 是否展示全勤奖
      otDays: {},
      attendanceData: {},
      extend: {
        attendance_belong_to: { type: '', after: '', before: '' },
        overtime_belong_to: { type: '', after: '', before: '' },
        update_salary_day_last_later: { type: '', after: '', before: '' }
      }
    }
  },
  computed: {
    fixClo() {
      return this.$route.query.type === '2' ? this.activeData.fixClo1 : this.activeData.fixClo
    },
    notFixClo() {
      return this.activeData.notFixClo
    }
  },
  async mounted() {
    await this.attendance()
    await this.get_salary()
  },
  methods: {
    // 删除导入项
    async handlerDel(row) {
      const res = await isDeleteToast(row)
      // 是否生成提示
      if (!res.data.is_del) {
        return this.$util.messageBox(this.$t('1387'), 'warning', () => {
          deleteItemImport(row).then(() => {
            this.$message.success(this.$t('806'))
            this.get_salary()
          })
        })
      }
      deleteItemImport(row).then(() => {
        this.$message.success(this.$t('806'))
        this.get_salary()
      })
    },
    get_salary() {
      // 工资设置数据
      get_salary({ payroll_sub_project_scheme_id: this.$route.params.id }).then(res => {
        if (res && res.code === 1) {
          const { fix, notfix, days, not_days, extend } = res.data
          const formatData = [
            { data: fix, key: 'fixTable', active: 'activeNames1' },
            { data: notfix, key: 'notFixTable', active: 'activeNames' },
            { data: extend, key: 'extend', active: 'activeNames2' }
          ]
          this.days = days
          this.not_days = not_days
          formatData.map((v, i) => {
            this[v.active] = []
            if (v.data && v.data.list) {
              v.data.list.forEach((table, tableIndex) => {
                // 手风琴默认全部打开
                this[v.active].push(tableIndex)
                if (table.list) {
                  table.list.forEach(item => {
                    item.cate_id = table.id
                    item.is_tax = item.is_tax === '1'
                    item.is_ss = item.is_ss === '1'
                  })
                }
              })
            } else this[v.active] = [0, 1, 2]
            // 给 notFixTable fixTable extend赋值
            this[v.key] = v.data
          })
          this.$nextTick(() => {
            const info = { notFixTable: {}, fixTable: {}, extend: {} }
            formatData.map((v, i) => {
              if (v.data && v.data.list) {
                v.data.list.forEach((table, tableIndex) => {
                  info[v.key][tableIndex] = []
                  if (table.ot_days) this.otDays = table.ot_days
                  table.list.forEach(item => {
                    if (item.is_select === '1') {
                      info[v.key][tableIndex].push(item)
                      this.$refs[`${v.key}${tableIndex}`][0].toggleRowSelection(item, true)
                    }
                  })
                  if (!info[v.key][tableIndex].length) delete info[v.key][tableIndex]
                })
              } else {
                info.extend = v.data
              }
            })
            // 拷贝初始数据
            this.cActiveInfo.notFixTable = JSON.parse(JSON.stringify(info.notFixTable))
            this.cActiveInfo.fixTable = JSON.parse(JSON.stringify(info.fixTable))
            this.cActiveInfo.extend = JSON.parse(JSON.stringify(extend))
          })
        }
      })
    },
    // 请求
    async attendance() {
      const res = await fullAttendanceBonusList()
      if (res.code !== 1 && res.data) return
      this.attendanceData = res.data
      this.is_show = this.attendanceData.pfa_list && this.attendanceData.pfa_list.length
      if (this.is_show) {
        this.attendanceData.pfa_list.forEach(item => {
          item.is_ss = item.is_ss === '1'
          item.is_tax = item.is_tax === '1'
          item.provide_way_1 = item.provide_way_1 ? item.provide_way_1 : { 1: '', 2: '', 3: '', 4: '' }
          item.staff = [...item.department_id, ...item.staff_info_ids]
        })
      }
    },
    handleGroup(val) {
      this.$set(this.extend[val], 'after', '')
      this.$set(this.extend[val], 'before', '')
      // this.extend[val].after = ''
      // this.extend[val].before = ''
    },
    handleOtDays(val) {
      this.otDays = val
    },
    saveData() {
      this.notFixTableSelectArr = []
      this.fixTableSelectArr = []
      for (const k in this.activeInfo.notFixTable) {
        this.activeInfo.notFixTable[k].forEach(v => this.notFixTableSelectArr.push(v))
      }
      for (const k in this.activeInfo.fixTable) {
        this.activeInfo.fixTable[k].forEach(v => this.fixTableSelectArr.push(v))
      }
      const { update_salary_day_last_later } = this.extend
      if (
        update_salary_day_last_later &&
        Number(update_salary_day_last_later.type) === 3 &&
        !update_salary_day_last_later.before &&
        !update_salary_day_last_later.after
      ) {
        this.$message.warning(this.$t('i18n.5653d71db6d74c1d96d8f9585dbe0f05'))
        return
      }
      const formateData = arr =>
        arr.map(v => ({
          id: v.id,
          cate_id: v.cate_id,
          val: v.val,
          is_ss: v.is_ss ? '1' : '0',
          is_tax: v.is_tax ? '1' : '0',
          days_type: v.days_type,
          days: v.days,
          not_days: v.not_days
        }))
      const query = {
        payroll_sub_project_scheme_id: this.$route.params.id,
        fix: formateData(this.fixTableSelectArr),
        notfix: formateData(this.notFixTableSelectArr),
        extend: this.extend
      }
      if (Object.keys(this.otDays).length) query.ot_days = this.otDays
      return save_salary(query)
    },
    selectable(row) {
      return row.if_select === '1'
    },
    notFixTableSelectHandle($event, index, obj) {
      this.activeInfo[obj][index] = $event
    },
    check(row, max) {
      Number(row.val) > max && (row.val = max)
      Number(row.val) < 0 && (row.val = '')
      row.val = Number(Number(row.val).toFixed(1))
    },
    checkExample(type) {
      this.$refs.example.init(type)
    }
  }
}
</script>
<style lang="scss" scoped>
.component {
  padding: 0 !important;
  .content {
    .clearfix {
      font-size: 14px;
      color: #8c8c8c;
      font-weight: normal;
      padding-bottom: 12px;
      .el-icon-warning {
        font-size: 16px;
        color: #5D51DA;
        margin-right: 4px;
      }
    }
    &:first-child {
      border-bottom: 1px dashed #d9d9d9;
    }
  }
}
.salary-box {
  padding-top: 5px;
  .salary-tip {
    font-size: 14px;
    padding-bottom: 5px;
  }

  .salary-con {
    padding-left: 20px;
    display: block;
    .el-radio {
      display: block;
      padding-bottom: 10px;
    }
    &-sub {
      padding-left: 20px;
      font-size: 14px;
      p {
        padding-bottom: 5px;
      }
    }
  }
}

.table {
  margin-top: 24px;
}
/deep/.input-number {
  max-width: 80px;
  span {
    background: #fff;
  }
  .el-input__inner {
    padding: 0 34px 0 2px;
  }
}
.el-input {
  max-width: 52px;
  /deep/ .el-input__inner {
    width: 100%;
    padding: 0 2px;
  }
}

.el-select {
  /deep/ .el-input {
    max-width: 100%;
  }
}
.add-more {
  display: block;
  width: 100%;
  margin-top: 10px;
  border-style: dashed;
}
.ot {
  padding: 10px 0;
  .icon {
    width: 16px;
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 10px;
  }
}
</style>
